import { toWSDateString } from "@wingspanhq/fe-component-library";
import {
  IPayeeResponse,
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { usePayeeDownloadW9 } from "../../../../../../query/payee/mutations/usePayeeDownloadW9";
import { getIsDomesticMember } from "../../../../../../query/users/selectors";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import { useRequirementDefaultActions } from "../../../../hooks/useRequirementDefaultActions";
import {
  CellsConfig,
  ContextItem,
  RequirementAction,
  RequirementContextType,
  RequirementTableCallback
} from "../../../../types";
import { getTaxVerificationRequirementName } from "../helpers/getTaxVerificationRequirementName";
import { getTaxVerificationRequirementPayeeStatusCell } from "../helpers/getTaxVerificationRequirementPayeeStatusCell";

export const usePayeeTaxVerificationConfig = (
  callback: RequirementTableCallback
): CellsConfig<
  IRequirementResponse,
  ContextItem,
  {
    payee?: IPayeeResponse;
  }
> => {
  const [downloadW9] = usePayeeDownloadW9();

  const defaultRequirementActions = useRequirementDefaultActions(
    RequirementContextType.Payee,
    callback
  );

  return {
    isActionRequired: () => false,

    requirementName: getTaxVerificationRequirementName,

    nameCell: requirement => ({
      text: getTaxVerificationRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.requirementType
      }),

    statusCell: getTaxVerificationRequirementPayeeStatusCell,

    toolbarActions: (requirement, context, additionalData) => {
      const actions: RequirementAction[] = [];

      const isDomesticPayee = additionalData.payee?.member
        ? getIsDomesticMember(additionalData.payee.member)
        : false;

      if (
        // requirement.dataSourceMetadata &&
        isDomesticPayee &&
        requirement.status === RequirementStatus.Complete
      ) {
        actions.push({
          label: "Download PDF",
          icon: "download",
          onClick: () => {
            if (!additionalData.payee?.payeeId) {
              return;
            }

            downloadW9({
              payeeId: additionalData.payee?.payeeId,
              filename:
                additionalData.payee?.user?.email ||
                `${toWSDateString(new Date(), "monthDayYear")}`
            });
          }
        });
      }

      const { extendToolbarActions } = defaultRequirementActions(
        requirement,
        context,
        additionalData,
        getTaxVerificationRequirementPayeeStatusCell(requirement)
      );

      return extendToolbarActions(actions);
    }
  };
};
